import { history, useModel } from '@umijs/max';
import { useEffect } from 'react';
import {
  applyMenuNavigateResult,
  canAccessPathByMenuState,
  findMenuPathByPath,
  getMenuChildren,
  isMenuAccessPending,
  isSystemPublicPath,
  resolveMenuGroupRedirectTarget,
} from '@/utils/menu';

/**
 * 菜单加载完成后再做路径权限校验（读取最新的 @@initialState，避免 layout onPageChange 闭包过期）
 */
const MenuAccessGuard = () => {
  const { initialState } = useModel('@@initialState');
  const pending = isMenuAccessPending(initialState);

  useEffect(() => {
    if (!initialState?.currentUser || pending) {
      return;
    }

    const runCheck = () => {
      const { pathname } = history.location;
      const menuData = initialState.menuData || [];

      if (isSystemPublicPath(pathname)) {
        return;
      }

      const menuState = {
        menuData,
        rawMenuData: initialState.rawMenuData || [],
        menuDataLoaded: Boolean(initialState.menuDataLoaded),
        menuSource: initialState.menuSource || 'backend',
      };

      const matchedChain = findMenuPathByPath(menuData, pathname);
      const currentNode = matchedChain?.[matchedChain.length - 1];
      const childMenus = currentNode ? getMenuChildren(currentNode) : undefined;
      if (childMenus?.length) {
        const result = resolveMenuGroupRedirectTarget(
          pathname,
          menuData,
          undefined,
          menuState.menuSource,
        );
        if (
          applyMenuNavigateResult(result, pathname, menuData, (path) =>
            history.replace(path),
          )
        ) {
          return;
        }
      }

      if (!canAccessPathByMenuState(pathname, menuState)) {
        history.replace('/404');
      }
    };

    runCheck();
    return history.listen(() => {
      runCheck();
    });
  }, [
    initialState?.currentUser,
    initialState?.menuDataLoaded,
    initialState?.menuLoading,
    initialState?.menuData,
    initialState?.rawMenuData,
    initialState?.menuSource,
    pending,
  ]);

  return null;
};

export default MenuAccessGuard;
